import { Taxonomy } from "../categories";
import { ProfitLossTableReportSection } from "../dto/reports/reports-common.dto";
import { AccountType } from "../constants/domains/accounting/accounts";

export const profitLossSectionLabels: Record<
    ProfitLossTableReportSection,
    string
> = {
    [ProfitLossTableReportSection.INCOME]: "Income",
    [ProfitLossTableReportSection.COGS]: "Cost of Goods Sold",
    [ProfitLossTableReportSection.GROSS_PROFIT]: "Gross Profit",
    [ProfitLossTableReportSection.EXPENSES]: "Expenses",
    [ProfitLossTableReportSection.NET_OPERATING_INCOME]: "Net Operating Income",
    [ProfitLossTableReportSection.OTHER_INCOME]: "Other Income",
    [ProfitLossTableReportSection.OTHER_EXPENSES]: "Other Expenses",
    [ProfitLossTableReportSection.NET_OTHER_INCOME]: "Net Other Income",
    [ProfitLossTableReportSection.NET_INCOME]: "Net Income",
    [ProfitLossTableReportSection.CASH_BALANCE]: "",
};

export const profitLossSectionCategoryMap: Record<
    ProfitLossTableReportSection,
    Taxonomy[]
> = {
    [ProfitLossTableReportSection.INCOME]: [Taxonomy.income],
    [ProfitLossTableReportSection.COGS]: [
        Taxonomy.cogs,
        Taxonomy.direct_labor,
        Taxonomy.goods_materials,
        Taxonomy.other_cogs,
    ],
    [ProfitLossTableReportSection.EXPENSES]: [
        Taxonomy.advertising_marketing,
        Taxonomy.client_gifts,
        Taxonomy.learning_development,
        Taxonomy.auto_vehicle,
        Taxonomy.auto_insurance,
        Taxonomy.auto_payment,
        Taxonomy.parking_tolls,
        Taxonomy.communications,
        Taxonomy.entertainment,
        Taxonomy.fees,
        Taxonomy.merchant_bank_fees,
        Taxonomy.licenses_permits,
        Taxonomy.insurance,
        Taxonomy.health_insurance,
        Taxonomy.life_insurance,
        Taxonomy.property_insurance,
        Taxonomy.legal_professional,
        Taxonomy.meals,
        Taxonomy.payroll,
        Taxonomy.employee_benefits,
        Taxonomy.retirement_benefits,
        Taxonomy.contractors,
        Taxonomy.salaries_wages,
        Taxonomy.payroll_taxes,
        Taxonomy.rentals_leases,
        Taxonomy.repairs_maintenance,
        Taxonomy.software_subscriptions,
        Taxonomy.travel,
        Taxonomy.utilities,
        Taxonomy.supplies_equipment,
        Taxonomy.office_postage,
        Taxonomy.furniture_fixtures,
        Taxonomy.props_production,
        Taxonomy.property_taxes,

        Taxonomy.business_office,
        Taxonomy.equipment_rentals,
        Taxonomy.management_fees,

        Taxonomy.charitable_contributions,
    ],
    [ProfitLossTableReportSection.OTHER_EXPENSES]: [
        Taxonomy.penalties_fines,
        Taxonomy.taxes,

        Taxonomy.federal_taxes,
        Taxonomy.local_taxes,
        Taxonomy.interest_paid,
    ],
    [ProfitLossTableReportSection.GROSS_PROFIT]: [],
    [ProfitLossTableReportSection.OTHER_INCOME]: [
        Taxonomy.interest_income,
        Taxonomy.other_income,
    ],
    [ProfitLossTableReportSection.NET_OPERATING_INCOME]: [],
    [ProfitLossTableReportSection.NET_OTHER_INCOME]: [],
    [ProfitLossTableReportSection.NET_INCOME]: [],
    [ProfitLossTableReportSection.CASH_BALANCE]: [
        Taxonomy.contributions_distributions,
        Taxonomy.transfer,
        Taxonomy.security_deposit,
        Taxonomy.investment,
        Taxonomy.credit_card_loans,
        Taxonomy.line_of_credit,
    ],
};

export const profitLossSectionCategoryToAccountTypeMap: Record<
    ProfitLossTableReportSection,
    AccountType[]
> = {
    [ProfitLossTableReportSection.INCOME]: [AccountType.income],
    [ProfitLossTableReportSection.COGS]: [AccountType.cogs],
    [ProfitLossTableReportSection.EXPENSES]: [AccountType.operatingExpenses],
    [ProfitLossTableReportSection.OTHER_EXPENSES]: [AccountType.otherExpenses],
    [ProfitLossTableReportSection.GROSS_PROFIT]: [],
    [ProfitLossTableReportSection.OTHER_INCOME]: [AccountType.otherIncome],
    [ProfitLossTableReportSection.NET_OPERATING_INCOME]: [],
    [ProfitLossTableReportSection.NET_OTHER_INCOME]: [],
    [ProfitLossTableReportSection.NET_INCOME]: [],
    [ProfitLossTableReportSection.CASH_BALANCE]: [],
};
